import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import Markdown from 'react-remarkable';

export const Card = ({
  node,
  imageCreditGlobal,
  articleIcon,
  videoIcon,
  isM3M
}) => (
  <div
    key={`${node.title}-conferenceRow`}
    className="c-conference-fb__conference-card">
    {node.slug ? (
      <Link
        className="c-conference-fb__link"
        to={`/${node.slug}/`.toLowerCase()}>
        <div className="c-conference-fb__img-wrapper">
          {node.thumbnailImage && (
            <Img
              className="c-conference-fb__img"
              fluid={node.thumbnailImage.fluid}
            />
          )}
          {!node.thumbnailImage &&
            node.heroImage && (
              <Img
                className="c-conference-fb__img"
                fluid={node.heroImage.fluid}
              />
            )}
        </div>

        <div className="c-conference-fb__inner-card">
          <h3
            className={
              isM3M
                ? 'c-conference-fb__card-title-m3m'
                : 'c-conference-fb__card-title'
            }>
            {node.title}
          </h3>
          {node.sponsor && (
            <div className="c-conference-fb__sponsor-text">
              <Markdown options={{ html: true }}>{`${
                node.sponsor.description.description
              }`}</Markdown>
            </div>
          )}
          {node.thumbnailImage &&
            node.thumbnailImageCredit && (
              <p className="c-conference-fb__credit-text">{`${imageCreditGlobal}: ${
                node.thumbnailImageCredit
              }`}</p>
            )}
          {articleIcon && (
            <img
              className="c-conference-fb__card-icon article-icon"
              src={`${articleIcon}`}
              alt="Article Icon"
            />
          )}
          {!node.articlesOnly &&
            videoIcon && (
              <img
                className="c-conference-fb__card-icon video-icon"
                src={`${videoIcon}`}
                alt="Video Icon"
              />
            )}
        </div>
      </Link>
    ) : (
      <a
        className="c-conference-fb__link"
        href={`${node.linkToConference}`}
        title={`${node.title}`}>
        <div className="c-conference-fb__img-wrapper">
          {node.thumbnailImage && (
            <Img
              className="c-conference-fb__img"
              fluid={node.thumbnailImage.fluid}
            />
          )}
          {!node.thumbnailImage &&
            node.heroImage && (
              <Img
                className="c-conference-fb__img"
                fluid={node.heroImage.fluid}
              />
            )}
        </div>

        <div className="c-conference-fb__inner-card">
          <h3
            className={
              isM3M
                ? 'c-conference-fb__card-title-m3m'
                : 'c-conference-fb__card-title'
            }>
            {node.title}
          </h3>
          {node.sponsor && (
            <div className="c-conference-fb__sponsor-text">
              <Markdown options={{ html: true }}>{`${
                node.sponsor.description.description
              }`}</Markdown>
            </div>
          )}
          {node.thumbnailImage &&
            node.thumbnailImageCredit && (
              <p className="c-conference-fb__credit-text">{`${imageCreditGlobal}: ${
                node.thumbnailImageCredit
              }`}</p>
            )}
          {articleIcon && (
            <img
              className="c-conference-fb__card-icon article-icon"
              src={`${articleIcon}`}
              alt="Article Icon"
            />
          )}
          {!node.articlesOnly &&
            videoIcon && (
              <img
                className="c-conference-fb__card-icon video-icon"
                src={`${videoIcon}`}
                alt="Video Icon"
              />
            )}
        </div>
      </a>
    )}
  </div>
);

export default Card;

Card.propTypes = {
  node: PropTypes.object,
  imageCreditGlobal: PropTypes.string,
  articleIcon: PropTypes.string,
  videoIcon: PropTypes.string,
  isM3M: PropTypes.bool
};
